import React from 'react';
import classnames from 'classnames';
import styles from './template-thumbnail.css';

interface TemplateThumbnailProps {
  /** Template name */
  name: string;
  /** URL to the image of the template */
  image: string;
  /** Provides visual elements that indicate that the template is selected */
  selected?: boolean;
  /** Adds additional classes to the component. */
  className?: string;
  /** Provides a data-testid */
  'data-testid'?: string;
}

/**
 * TemplateThumbnail Component
 * @param {TemplateThumbnailProps} props
 *
 * @returns JSX.ELEMENT
 */
export const TemplateThumbnail = ({
  className,
  name,
  image,
  selected = false,
  'data-testid': dataTestid
}: TemplateThumbnailProps) => {
  const thumbnailClasses = classnames(styles.thumbnail, className, {
    [styles.selected]: selected
  });

  return (
    <div role="button" tabIndex={0} className={thumbnailClasses} data-testid={dataTestid}>
      <div className={styles.imageWrapper}>
        <img className={styles.image} src={image} />
      </div>
      <div className={styles.name}>{name}</div>
    </div>
  );
};

export default TemplateThumbnail;
